export const esgData = [
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2015,
    "Revenue": 459.2,
    "ProfitMargin": 6,
    "MarketCap": 337.5,
    "GrowthRate": 4.1,
    "ESG_Overall": 57,
    "ESG_Environmental": 60.7,
    "ESG_Social": 33.5,
    "ESG_Governance": 76.8,
    "CarbonEmissions": 35577.4,
    "WaterUsage": 17788.7,
    "EnergyConsumption": 71154.7
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2016,
    "Revenue": 473.8,
    "ProfitMargin": 4.6,
    "MarketCap": 366.6,
    "GrowthRate": 3.2,
    "ESG_Overall": 56.7,
    "ESG_Environmental": 58.9,
    "ESG_Social": 32.8,
    "ESG_Governance": 78.5,
    "CarbonEmissions": 37314.7,
    "WaterUsage": 18657.4,
    "EnergyConsumption": 74629.4
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2017,
    "Revenue": 564.9,
    "ProfitMargin": 5.2,
    "MarketCap": 313.4,
    "GrowthRate": 19.2,
    "ESG_Overall": 56.5,
    "ESG_Environmental": 57.6,
    "ESG_Social": 34,
    "ESG_Governance": 77.8,
    "CarbonEmissions": 45006.4,
    "WaterUsage": 22503.2,
    "EnergyConsumption": 90012.9
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2018,
    "Revenue": 558.4,
    "ProfitMargin": 4.3,
    "MarketCap": 283,
    "GrowthRate": -1.1,
    "ESG_Overall": 58,
    "ESG_Environmental": 62.3,
    "ESG_Social": 33.4,
    "ESG_Governance": 78.3,
    "CarbonEmissions": 42650.1,
    "WaterUsage": 21325.1,
    "EnergyConsumption": 85300.2
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2019,
    "Revenue": 554.5,
    "ProfitMargin": 4.9,
    "MarketCap": 538.1,
    "GrowthRate": -0.7,
    "ESG_Overall": 56.6,
    "ESG_Environmental": 63.7,
    "ESG_Social": 30,
    "ESG_Governance": 76.1,
    "CarbonEmissions": 41799.4,
    "WaterUsage": 20899.7,
    "EnergyConsumption": 83598.8
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2020,
    "Revenue": 567.5,
    "ProfitMargin": 6,
    "MarketCap": 384.1,
    "GrowthRate": 2.3,
    "ESG_Overall": 55.7,
    "ESG_Environmental": 65.1,
    "ESG_Social": 28.5,
    "ESG_Governance": 73.5,
    "CarbonEmissions": 42245.4,
    "WaterUsage": 21122.7,
    "EnergyConsumption": 84490.9
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2021,
    "Revenue": 604.2,
    "ProfitMargin": 5.2,
    "MarketCap": 479.3,
    "GrowthRate": 6.5,
    "ESG_Overall": 55.6,
    "ESG_Environmental": 66.8,
    "ESG_Social": 25.5,
    "ESG_Governance": 74.6,
    "CarbonEmissions": 44263.8,
    "WaterUsage": 22131.9,
    "EnergyConsumption": 88527.7
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2022,
    "Revenue": 593.2,
    "ProfitMargin": 4.2,
    "MarketCap": 248.4,
    "GrowthRate": -1.8,
    "ESG_Overall": 57.7,
    "ESG_Environmental": 69,
    "ESG_Social": 27.1,
    "ESG_Governance": 76.9,
    "CarbonEmissions": 42536.3,
    "WaterUsage": 21268.2,
    "EnergyConsumption": 85072.6
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2023,
    "Revenue": 636.7,
    "ProfitMargin": 5.3,
    "MarketCap": 373.9,
    "GrowthRate": 7.3,
    "ESG_Overall": 57.8,
    "ESG_Environmental": 68.3,
    "ESG_Social": 27,
    "ESG_Governance": 78.1,
    "CarbonEmissions": 45956.3,
    "WaterUsage": 22978.2,
    "EnergyConsumption": 91912.6
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2024,
    "Revenue": 687,
    "ProfitMargin": 4.6,
    "MarketCap": 460.1,
    "GrowthRate": 7.9,
    "ESG_Overall": 58.5,
    "ESG_Environmental": 68.9,
    "ESG_Social": 29.9,
    "ESG_Governance": 76.8,
    "CarbonEmissions": 49289.1,
    "WaterUsage": 24644.5,
    "EnergyConsumption": 98578.1
  },
  {
    "CompanyID": 1,
    "CompanyName": "Nintendo",
    "Industry": "Retail",
    "Region": "Latin America",
    "Year": 2025,
    "Revenue": 734.5,
    "ProfitMargin": 5,
    "MarketCap": 628.8,
    "GrowthRate": 6.9,
    "ESG_Overall": 59.2,
    "ESG_Environmental": 70.7,
    "ESG_Social": 29.1,
    "ESG_Governance": 78,
    "CarbonEmissions": 51805.8,
    "WaterUsage": 25902.9,
    "EnergyConsumption": 103611.7
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2015,
    "Revenue": 2934.8,
    "ProfitMargin": -2.9,
    "MarketCap": 1803.1,
    "GrowthRate": 2.5,
    "ESG_Overall": 59.9,
    "ESG_Environmental": 61.1,
    "ESG_Social": 48.6,
    "ESG_Governance": 69.8,
    "CarbonEmissions": 226554.2,
    "WaterUsage": 113277.1,
    "EnergyConsumption": 453108.3
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2016,
    "Revenue": 3140.3,
    "ProfitMargin": -1.1,
    "MarketCap": 13885.2,
    "GrowthRate": 7,
    "ESG_Overall": 60.6,
    "ESG_Environmental": 61.1,
    "ESG_Social": 50.1,
    "ESG_Governance": 70.5,
    "CarbonEmissions": 242555.1,
    "WaterUsage": 121277.6,
    "EnergyConsumption": 485110.3
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2017,
    "Revenue": 3463.1,
    "ProfitMargin": -2.2,
    "MarketCap": 5283.7,
    "GrowthRate": 10.3,
    "ESG_Overall": 61.7,
    "ESG_Environmental": 61.4,
    "ESG_Social": 53.1,
    "ESG_Governance": 70.5,
    "CarbonEmissions": 266651.3,
    "WaterUsage": 133325.7,
    "EnergyConsumption": 533302.7
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2018,
    "Revenue": 2939.7,
    "ProfitMargin": -1.7,
    "MarketCap": 4408,
    "GrowthRate": -15.1,
    "ESG_Overall": 61.5,
    "ESG_Environmental": 61.7,
    "ESG_Social": 52,
    "ESG_Governance": 70.6,
    "CarbonEmissions": 225701.3,
    "WaterUsage": 112850.6,
    "EnergyConsumption": 451402.6
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2019,
    "Revenue": 3125.6,
    "ProfitMargin": 1.2,
    "MarketCap": 566.4,
    "GrowthRate": 6.3,
    "ESG_Overall": 61.1,
    "ESG_Environmental": 63.1,
    "ESG_Social": 52.5,
    "ESG_Governance": 67.8,
    "CarbonEmissions": 237019.5,
    "WaterUsage": 118509.7,
    "EnergyConsumption": 474039
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2020,
    "Revenue": 2999.8,
    "ProfitMargin": -0.3,
    "MarketCap": 1997.8,
    "GrowthRate": -4,
    "ESG_Overall": 63.3,
    "ESG_Environmental": 64.2,
    "ESG_Social": 57.9,
    "ESG_Governance": 67.9,
    "CarbonEmissions": 225128.2,
    "WaterUsage": 112564.1,
    "EnergyConsumption": 450256.4
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2021,
    "Revenue": 3167.9,
    "ProfitMargin": -0.4,
    "MarketCap": 15634.9,
    "GrowthRate": 5.6,
    "ESG_Overall": 63,
    "ESG_Environmental": 62.9,
    "ESG_Social": 60,
    "ESG_Governance": 66.1,
    "CarbonEmissions": 240710.6,
    "WaterUsage": 120355.3,
    "EnergyConsumption": 481421.2
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2022,
    "Revenue": 3106.4,
    "ProfitMargin": 0.8,
    "MarketCap": 514.3,
    "GrowthRate": -1.9,
    "ESG_Overall": 64,
    "ESG_Environmental": 66.7,
    "ESG_Social": 57.7,
    "ESG_Governance": 67.8,
    "CarbonEmissions": 227761.4,
    "WaterUsage": 113880.7,
    "EnergyConsumption": 455522.7
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2023,
    "Revenue": 3691.6,
    "ProfitMargin": -0.7,
    "MarketCap": 2523.2,
    "GrowthRate": 18.8,
    "ESG_Overall": 66,
    "ESG_Environmental": 66.6,
    "ESG_Social": 61.6,
    "ESG_Governance": 70,
    "CarbonEmissions": 271015.1,
    "WaterUsage": 135507.6,
    "EnergyConsumption": 542030.3
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2024,
    "Revenue": 3822.9,
    "ProfitMargin": -1.2,
    "MarketCap": 5807.8,
    "GrowthRate": 3.6,
    "ESG_Overall": 65.7,
    "ESG_Environmental": 65.4,
    "ESG_Social": 63,
    "ESG_Governance": 68.7,
    "CarbonEmissions": 283660,
    "WaterUsage": 141830,
    "EnergyConsumption": 567320
  },
  {
    "CompanyID": 2,
    "CompanyName": "Toyota Motor Corp",
    "Industry": "Retail",
    "Region": "Asia",
    "Year": 2025,
    "Revenue": 4371.5,
    "ProfitMargin": -2.4,
    "MarketCap": 20376.3,
    "GrowthRate": 14.4,
    "ESG_Overall": 66.3,
    "ESG_Environmental": 65.8,
    "ESG_Social": 62.8,
    "ESG_Governance": 70.3,
    "CarbonEmissions": 323282,
    "WaterUsage": 161641,
    "EnergyConsumption": 646564.1
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2015,
    "Revenue": 259.7,
    "ProfitMargin": 5.9,
    "MarketCap": 140.2,
    "GrowthRate": 10.3,
    "ESG_Overall": 25.5,
    "ESG_Environmental": 3.3,
    "ESG_Social": 41.6,
    "ESG_Governance": 31.5,
    "CarbonEmissions": 183314.5,
    "WaterUsage": 30552.4,
    "EnergyConsumption": 611048.2
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2016,
    "Revenue": 245.2,
    "ProfitMargin": 8.5,
    "MarketCap": 224,
    "GrowthRate": -5.6,
    "ESG_Overall": 26.9,
    "ESG_Environmental": 7,
    "ESG_Social": 40.2,
    "ESG_Governance": 33.5,
    "CarbonEmissions": 169346.3,
    "WaterUsage": 28224.4,
    "EnergyConsumption": 564487.8
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2017,
    "Revenue": 282.4,
    "ProfitMargin": 6.5,
    "MarketCap": 289.7,
    "GrowthRate": 15.2,
    "ESG_Overall": 27.9,
    "ESG_Environmental": 8.8,
    "ESG_Social": 42.6,
    "ESG_Governance": 32.3,
    "CarbonEmissions": 192824.3,
    "WaterUsage": 32137.4,
    "EnergyConsumption": 642747.8
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2018,
    "Revenue": 300.2,
    "ProfitMargin": 3.1,
    "MarketCap": 100.7,
    "GrowthRate": 6.3,
    "ESG_Overall": 28.2,
    "ESG_Environmental": 8.3,
    "ESG_Social": 42.9,
    "ESG_Governance": 33.5,
    "CarbonEmissions": 205699.6,
    "WaterUsage": 34283.3,
    "EnergyConsumption": 685665.5
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2019,
    "Revenue": 322.6,
    "ProfitMargin": 5.1,
    "MarketCap": 290.7,
    "GrowthRate": 7.5,
    "ESG_Overall": 29.8,
    "ESG_Environmental": 14.8,
    "ESG_Social": 43.6,
    "ESG_Governance": 31.2,
    "CarbonEmissions": 212286.3,
    "WaterUsage": 35381,
    "EnergyConsumption": 707621
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2020,
    "Revenue": 337.9,
    "ProfitMargin": 2.7,
    "MarketCap": 76.5,
    "GrowthRate": 4.7,
    "ESG_Overall": 30.8,
    "ESG_Environmental": 17.7,
    "ESG_Social": 42,
    "ESG_Governance": 32.6,
    "CarbonEmissions": 218171.7,
    "WaterUsage": 36362,
    "EnergyConsumption": 727239
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2021,
    "Revenue": 348.4,
    "ProfitMargin": 4.5,
    "MarketCap": 128.8,
    "GrowthRate": 3.1,
    "ESG_Overall": 31.6,
    "ESG_Environmental": 18.5,
    "ESG_Social": 43.9,
    "ESG_Governance": 32.2,
    "CarbonEmissions": 223833,
    "WaterUsage": 37305.5,
    "EnergyConsumption": 746110
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2022,
    "Revenue": 389.6,
    "ProfitMargin": 7.1,
    "MarketCap": 327.9,
    "GrowthRate": 11.8,
    "ESG_Overall": 31.3,
    "ESG_Environmental": 18.8,
    "ESG_Social": 44.9,
    "ESG_Governance": 30.2,
    "CarbonEmissions": 249794.5,
    "WaterUsage": 41632.4,
    "EnergyConsumption": 832648.3
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2023,
    "Revenue": 415.2,
    "ProfitMargin": 8.1,
    "MarketCap": 498.7,
    "GrowthRate": 6.6,
    "ESG_Overall": 32.3,
    "ESG_Environmental": 20.2,
    "ESG_Social": 43.8,
    "ESG_Governance": 32.9,
    "CarbonEmissions": 263632.1,
    "WaterUsage": 43938.7,
    "EnergyConsumption": 878773.7
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2024,
    "Revenue": 438,
    "ProfitMargin": 10.3,
    "MarketCap": 739.4,
    "GrowthRate": 5.5,
    "ESG_Overall": 32.1,
    "ESG_Environmental": 23.4,
    "ESG_Social": 41.5,
    "ESG_Governance": 31.5,
    "CarbonEmissions": 272361.8,
    "WaterUsage": 45393.6,
    "EnergyConsumption": 907872.8
  },
  {
    "CompanyID": 3,
    "CompanyName": "Olympus Corp",
    "Industry": "Transportation",
    "Region": "Latin America",
    "Year": 2025,
    "Revenue": 479.8,
    "ProfitMargin": 11.6,
    "MarketCap": 1020.7,
    "GrowthRate": 9.5,
    "ESG_Overall": 34.3,
    "ESG_Environmental": 24.4,
    "ESG_Social": 43.7,
    "ESG_Governance": 34.9,
    "CarbonEmissions": 296242,
    "WaterUsage": 49373.7,
    "EnergyConsumption": 987473.3
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2015,
    "Revenue": 5036.7,
    "ProfitMargin": 21.2,
    "MarketCap": 23192.4,
    "GrowthRate": 5,
    "ESG_Overall": 54.2,
    "ESG_Environmental": 97.6,
    "ESG_Social": 46.2,
    "ESG_Governance": 18.9,
    "CarbonEmissions": 130146.6,
    "WaterUsage": 78087.9,
    "EnergyConsumption": 260293.2
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2016,
    "Revenue": 5192.5,
    "ProfitMargin": 25.1,
    "MarketCap": 25137.8,
    "GrowthRate": 3.1,
    "ESG_Overall": 54.6,
    "ESG_Environmental": 98.9,
    "ESG_Social": 45.2,
    "ESG_Governance": 19.9,
    "CarbonEmissions": 131888.8,
    "WaterUsage": 79133.3,
    "EnergyConsumption": 263777.6
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2017,
    "Revenue": 5497.1,
    "ProfitMargin": 23.4,
    "MarketCap": 33251,
    "GrowthRate": 5.9,
    "ESG_Overall": 55.9,
    "ESG_Environmental": 100,
    "ESG_Social": 47.4,
    "ESG_Governance": 20.4,
    "CarbonEmissions": 137428.2,
    "WaterUsage": 82456.9,
    "EnergyConsumption": 274856.3
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2018,
    "Revenue": 5978.5,
    "ProfitMargin": 26.1,
    "MarketCap": 31801,
    "GrowthRate": 8.8,
    "ESG_Overall": 55.6,
    "ESG_Environmental": 99.7,
    "ESG_Social": 46.3,
    "ESG_Governance": 20.7,
    "CarbonEmissions": 150000,
    "WaterUsage": 90000,
    "EnergyConsumption": 300000
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2019,
    "Revenue": 6529.4,
    "ProfitMargin": 28.2,
    "MarketCap": 42706.4,
    "GrowthRate": 9.2,
    "ESG_Overall": 56,
    "ESG_Environmental": 100,
    "ESG_Social": 46.1,
    "ESG_Governance": 21.8,
    "CarbonEmissions": 163234.8,
    "WaterUsage": 97940.9,
    "EnergyConsumption": 326469.6
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2020,
    "Revenue": 6123.5,
    "ProfitMargin": 30.6,
    "MarketCap": 38574.1,
    "GrowthRate": -6.2,
    "ESG_Overall": 58.4,
    "ESG_Environmental": 100,
    "ESG_Social": 50.9,
    "ESG_Governance": 24.4,
    "CarbonEmissions": 153087.8,
    "WaterUsage": 91852.7,
    "EnergyConsumption": 306175.6
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2021,
    "Revenue": 5784.3,
    "ProfitMargin": 29.4,
    "MarketCap": 37578.6,
    "GrowthRate": -5.5,
    "ESG_Overall": 60,
    "ESG_Environmental": 100,
    "ESG_Social": 55.1,
    "ESG_Governance": 24.8,
    "CarbonEmissions": 144607.6,
    "WaterUsage": 86764.6,
    "EnergyConsumption": 289215.2
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2022,
    "Revenue": 5711.3,
    "ProfitMargin": 26.1,
    "MarketCap": 35339.1,
    "GrowthRate": -1.3,
    "ESG_Overall": 60.5,
    "ESG_Environmental": 100,
    "ESG_Social": 58.9,
    "ESG_Governance": 22.5,
    "CarbonEmissions": 142781.6,
    "WaterUsage": 85669,
    "EnergyConsumption": 285563.2
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2023,
    "Revenue": 5844.2,
    "ProfitMargin": 26.5,
    "MarketCap": 34781.6,
    "GrowthRate": 2.3,
    "ESG_Overall": 62.6,
    "ESG_Environmental": 100,
    "ESG_Social": 64.1,
    "ESG_Governance": 23.8,
    "CarbonEmissions": 146104.4,
    "WaterUsage": 87662.6,
    "EnergyConsumption": 292208.7
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2024,
    "Revenue": 6555.1,
    "ProfitMargin": 26,
    "MarketCap": 45451.6,
    "GrowthRate": 12.2,
    "ESG_Overall": 63.5,
    "ESG_Environmental": 100,
    "ESG_Social": 64.8,
    "ESG_Governance": 25.6,
    "CarbonEmissions": 163877.9,
    "WaterUsage": 98326.7,
    "EnergyConsumption": 327755.8
  },
  {
    "CompanyID": 4,
    "CompanyName": "NTT Data Group",
    "Industry": "Technology",
    "Region": "Africa",
    "Year": 2025,
    "Revenue": 7675.6,
    "ProfitMargin": 22.9,
    "MarketCap": 42400.4,
    "GrowthRate": 17.1,
    "ESG_Overall": 64.1,
    "ESG_Environmental": 100,
    "ESG_Social": 65.4,
    "ESG_Governance": 27,
    "CarbonEmissions": 191891.1,
    "WaterUsage": 115134.7,
    "EnergyConsumption": 383782.3
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2015,
    "Revenue": 2720.9,
    "ProfitMargin": 16.1,
    "MarketCap": 3884.5,
    "GrowthRate": 3.5,
    "ESG_Overall": 43.5,
    "ESG_Environmental": 71.9,
    "ESG_Social": 19.1,
    "ESG_Governance": 39.4,
    "CarbonEmissions": 37894.7,
    "WaterUsage": 18947.3,
    "EnergyConsumption": 94736.7
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2016,
    "Revenue": 2647.4,
    "ProfitMargin": 17.6,
    "MarketCap": 9275.6,
    "GrowthRate": -2.7,
    "ESG_Overall": 42.5,
    "ESG_Environmental": 74.2,
    "ESG_Social": 16,
    "ESG_Governance": 37.4,
    "CarbonEmissions": 36048.3,
    "WaterUsage": 18024.2,
    "EnergyConsumption": 90120.8
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2017,
    "Revenue": 2553.4,
    "ProfitMargin": 19.9,
    "MarketCap": 9760.9,
    "GrowthRate": -3.6,
    "ESG_Overall": 44.3,
    "ESG_Environmental": 74.7,
    "ESG_Social": 18.7,
    "ESG_Governance": 39.6,
    "CarbonEmissions": 34565.5,
    "WaterUsage": 17282.7,
    "EnergyConsumption": 86413.7
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2018,
    "Revenue": 2758.9,
    "ProfitMargin": 22.6,
    "MarketCap": 7367.6,
    "GrowthRate": 8.1,
    "ESG_Overall": 45.4,
    "ESG_Environmental": 75.8,
    "ESG_Social": 18.7,
    "ESG_Governance": 41.8,
    "CarbonEmissions": 36945.9,
    "WaterUsage": 18472.9,
    "EnergyConsumption": 92364.7
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2019,
    "Revenue": 2746.9,
    "ProfitMargin": 21.3,
    "MarketCap": 11365.5,
    "GrowthRate": -0.4,
    "ESG_Overall": 46,
    "ESG_Environmental": 77,
    "ESG_Social": 20.4,
    "ESG_Governance": 40.7,
    "CarbonEmissions": 36325.1,
    "WaterUsage": 18162.6,
    "EnergyConsumption": 90812.9
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2020,
    "Revenue": 3243,
    "ProfitMargin": 19.3,
    "MarketCap": 10066.1,
    "GrowthRate": 18.1,
    "ESG_Overall": 46.8,
    "ESG_Environmental": 75.5,
    "ESG_Social": 22.5,
    "ESG_Governance": 42.5,
    "CarbonEmissions": 43534.1,
    "WaterUsage": 21767,
    "EnergyConsumption": 108835.2
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2021,
    "Revenue": 3120.1,
    "ProfitMargin": 19.3,
    "MarketCap": 8787.3,
    "GrowthRate": -3.8,
    "ESG_Overall": 47.5,
    "ESG_Environmental": 78.5,
    "ESG_Social": 22.7,
    "ESG_Governance": 41.3,
    "CarbonEmissions": 40596.3,
    "WaterUsage": 20298.2,
    "EnergyConsumption": 101490.8
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2022,
    "Revenue": 3094.2,
    "ProfitMargin": 20.1,
    "MarketCap": 9600.4,
    "GrowthRate": -0.8,
    "ESG_Overall": 47.6,
    "ESG_Environmental": 78.4,
    "ESG_Social": 22.3,
    "ESG_Governance": 42.3,
    "CarbonEmissions": 40314,
    "WaterUsage": 20157,
    "EnergyConsumption": 100785.1
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2023,
    "Revenue": 3281.7,
    "ProfitMargin": 21.9,
    "MarketCap": 6441.8,
    "GrowthRate": 6.1,
    "ESG_Overall": 45.9,
    "ESG_Environmental": 76.5,
    "ESG_Social": 20,
    "ESG_Governance": 41.3,
    "CarbonEmissions": 43628.2,
    "WaterUsage": 21814.1,
    "EnergyConsumption": 109070.6
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2024,
    "Revenue": 3282.1,
    "ProfitMargin": 22.5,
    "MarketCap": 9663,
    "GrowthRate": 0,
    "ESG_Overall": 47.4,
    "ESG_Environmental": 80.4,
    "ESG_Social": 19.9,
    "ESG_Governance": 41.8,
    "CarbonEmissions": 41818.8,
    "WaterUsage": 20909.4,
    "EnergyConsumption": 104546.9
  },
  {
    "CompanyID": 5,
    "CompanyName": "Oriental Land Co Ltd",
    "Industry": "Finance",
    "Region": "Middle East",
    "Year": 2025,
    "Revenue": 3162.1,
    "ProfitMargin": 22.4,
    "MarketCap": 6674.6,
    "GrowthRate": -3.7,
    "ESG_Overall": 48,
    "ESG_Environmental": 82.1,
    "ESG_Social": 18.7,
    "ESG_Governance": 43.3,
    "CarbonEmissions": 39561.3,
    "WaterUsage": 19780.6,
    "EnergyConsumption": 98903.2
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2015,
    "Revenue": 2339.1,
    "ProfitMargin": 0.8,
    "MarketCap": 256.7,
    "GrowthRate": 4,
    "ESG_Overall": 69.1,
    "ESG_Environmental": 56.9,
    "ESG_Social": 76.8,
    "ESG_Governance": 73.7,
    "CarbonEmissions": 1125550.2,
    "WaterUsage": 187591.7,
    "EnergyConsumption": 3751834
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2016,
    "Revenue": 2574.5,
    "ProfitMargin": -1,
    "MarketCap": 11890.9,
    "GrowthRate": 10.1,
    "ESG_Overall": 68.4,
    "ESG_Environmental": 56.1,
    "ESG_Social": 76.9,
    "ESG_Governance": 72.2,
    "CarbonEmissions": 1246956.8,
    "WaterUsage": 207826.1,
    "EnergyConsumption": 4156522.6
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2017,
    "Revenue": 2508.9,
    "ProfitMargin": -4,
    "MarketCap": 3844.3,
    "GrowthRate": -2.6,
    "ESG_Overall": 68.7,
    "ESG_Environmental": 60.3,
    "ESG_Social": 75.8,
    "ESG_Governance": 70,
    "CarbonEmissions": 1171117,
    "WaterUsage": 195186.2,
    "EnergyConsumption": 3903723.3
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2018,
    "Revenue": 2472.4,
    "ProfitMargin": -8.2,
    "MarketCap": 1595.7,
    "GrowthRate": -1.5,
    "ESG_Overall": 66.9,
    "ESG_Environmental": 60,
    "ESG_Social": 73.1,
    "ESG_Governance": 67.5,
    "CarbonEmissions": 1157116.5,
    "WaterUsage": 192852.8,
    "EnergyConsumption": 3857055.1
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2019,
    "Revenue": 2598.8,
    "ProfitMargin": -8.5,
    "MarketCap": 8095.7,
    "GrowthRate": 5.1,
    "ESG_Overall": 68.7,
    "ESG_Environmental": 62.3,
    "ESG_Social": 73.8,
    "ESG_Governance": 70.1,
    "CarbonEmissions": 1191171.2,
    "WaterUsage": 198528.5,
    "EnergyConsumption": 3970570.6
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2020,
    "Revenue": 2563.3,
    "ProfitMargin": -11.4,
    "MarketCap": 10251.2,
    "GrowthRate": -1.4,
    "ESG_Overall": 70.5,
    "ESG_Environmental": 64,
    "ESG_Social": 74.3,
    "ESG_Governance": 73.3,
    "CarbonEmissions": 1156823.6,
    "WaterUsage": 192803.9,
    "EnergyConsumption": 3856078.8
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2021,
    "Revenue": 2466.6,
    "ProfitMargin": -8.5,
    "MarketCap": 7550,
    "GrowthRate": -3.8,
    "ESG_Overall": 70.8,
    "ESG_Environmental": 64.2,
    "ESG_Social": 75.3,
    "ESG_Governance": 72.9,
    "CarbonEmissions": 1110593.7,
    "WaterUsage": 185099,
    "EnergyConsumption": 3701979
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2022,
    "Revenue": 2747.5,
    "ProfitMargin": -7.9,
    "MarketCap": 12663.9,
    "GrowthRate": 11.4,
    "ESG_Overall": 72.5,
    "ESG_Environmental": 68.4,
    "ESG_Social": 77,
    "ESG_Governance": 72.1,
    "CarbonEmissions": 1188684.3,
    "WaterUsage": 198114,
    "EnergyConsumption": 3962281
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2023,
    "Revenue": 3009.5,
    "ProfitMargin": -9.8,
    "MarketCap": 4910,
    "GrowthRate": 9.5,
    "ESG_Overall": 71.7,
    "ESG_Environmental": 68.1,
    "ESG_Social": 75.7,
    "ESG_Governance": 71.2,
    "CarbonEmissions": 1305812.3,
    "WaterUsage": 217635.4,
    "EnergyConsumption": 4352707.7
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2024,
    "Revenue": 3095.6,
    "ProfitMargin": -8.6,
    "MarketCap": 2201.1,
    "GrowthRate": 2.9,
    "ESG_Overall": 69.5,
    "ESG_Environmental": 62.2,
    "ESG_Social": 75.7,
    "ESG_Governance": 70.7,
    "CarbonEmissions": 1420617.4,
    "WaterUsage": 236769.6,
    "EnergyConsumption": 4735391.3
  },
  {
    "CompanyID": 6,
    "CompanyName": "Nippon Steel",
    "Industry": "Transportation",
    "Region": "Oceania",
    "Year": 2025,
    "Revenue": 3297,
    "ProfitMargin": -10,
    "MarketCap": 7887.8,
    "GrowthRate": 6.5,
    "ESG_Overall": 73.1,
    "ESG_Environmental": 68.2,
    "ESG_Social": 77.4,
    "ESG_Governance": 73.6,
    "CarbonEmissions": 1428863.2,
    "WaterUsage": 238143.9,
    "EnergyConsumption": 4762877.2
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2015,
    "Revenue": 4664.1,
    "ProfitMargin": 6.2,
    "MarketCap": 4597.8,
    "GrowthRate": 4.5,
    "ESG_Overall": 53,
    "ESG_Environmental": 74.6,
    "ESG_Social": 37.1,
    "ESG_Governance": 47.5,
    "CarbonEmissions": 316163.3,
    "WaterUsage": 316163.3,
    "EnergyConsumption": 632326.6
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2016,
    "Revenue": 5080.6,
    "ProfitMargin": 9,
    "MarketCap": 6228.6,
    "GrowthRate": 8.9,
    "ESG_Overall": 52.4,
    "ESG_Environmental": 72.7,
    "ESG_Social": 38.3,
    "ESG_Governance": 46.1,
    "CarbonEmissions": 351094.3,
    "WaterUsage": 351094.3,
    "EnergyConsumption": 702188.6
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2017,
    "Revenue": 5192,
    "ProfitMargin": 6.4,
    "MarketCap": 7750.2,
    "GrowthRate": 2.2,
    "ESG_Overall": 53.9,
    "ESG_Environmental": 77.8,
    "ESG_Social": 38.1,
    "ESG_Governance": 45.7,
    "CarbonEmissions": 340222.4,
    "WaterUsage": 340222.4,
    "EnergyConsumption": 680444.7
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2018,
    "Revenue": 5320.5,
    "ProfitMargin": 4.3,
    "MarketCap": 2608,
    "GrowthRate": 2.5,
    "ESG_Overall": 53.4,
    "ESG_Environmental": 77.7,
    "ESG_Social": 38.4,
    "ESG_Governance": 44.2,
    "CarbonEmissions": 349079,
    "WaterUsage": 349079,
    "EnergyConsumption": 698158.1
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2019,
    "Revenue": 5421.6,
    "ProfitMargin": 1.3,
    "MarketCap": 1267,
    "GrowthRate": 1.9,
    "ESG_Overall": 54.4,
    "ESG_Environmental": 78.5,
    "ESG_Social": 39,
    "ESG_Governance": 45.7,
    "CarbonEmissions": 352693.8,
    "WaterUsage": 352693.8,
    "EnergyConsumption": 705387.6
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2020,
    "Revenue": 6225.1,
    "ProfitMargin": 3.5,
    "MarketCap": 4571.3,
    "GrowthRate": 14.8,
    "ESG_Overall": 53.9,
    "ESG_Environmental": 78.3,
    "ESG_Social": 38.5,
    "ESG_Governance": 45,
    "CarbonEmissions": 406012.5,
    "WaterUsage": 406012.5,
    "EnergyConsumption": 812025.1
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2021,
    "Revenue": 6470.9,
    "ProfitMargin": -2.3,
    "MarketCap": 21238.4,
    "GrowthRate": 3.9,
    "ESG_Overall": 53.3,
    "ESG_Environmental": 78,
    "ESG_Social": 34.6,
    "ESG_Governance": 47.2,
    "CarbonEmissions": 423188.3,
    "WaterUsage": 423188.3,
    "EnergyConsumption": 846376.6
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2022,
    "Revenue": 6387.4,
    "ProfitMargin": -2.2,
    "MarketCap": 18488.5,
    "GrowthRate": -1.3,
    "ESG_Overall": 53.9,
    "ESG_Environmental": 80.9,
    "ESG_Social": 34.8,
    "ESG_Governance": 45.8,
    "CarbonEmissions": 404596.4,
    "WaterUsage": 404596.4,
    "EnergyConsumption": 809192.9
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2023,
    "Revenue": 6014.8,
    "ProfitMargin": -1.7,
    "MarketCap": 10294.8,
    "GrowthRate": -5.8,
    "ESG_Overall": 53.7,
    "ESG_Environmental": 81.6,
    "ESG_Social": 35.2,
    "ESG_Governance": 44.2,
    "CarbonEmissions": 378353.9,
    "WaterUsage": 378353.9,
    "EnergyConsumption": 756707.8
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2024,
    "Revenue": 6084.6,
    "ProfitMargin": -3.6,
    "MarketCap": 27425.5,
    "GrowthRate": 1.2,
    "ESG_Overall": 55.8,
    "ESG_Environmental": 81.9,
    "ESG_Social": 39.1,
    "ESG_Governance": 46.5,
    "CarbonEmissions": 381475.3,
    "WaterUsage": 381475.3,
    "EnergyConsumption": 762950.7
  },
  {
    "CompanyID": 7,
    "CompanyName": "Bridgestone",
    "Industry": "Healthcare",
    "Region": "Oceania",
    "Year": 2025,
    "Revenue": 6444.2,
    "ProfitMargin": 0.1,
    "MarketCap": 38,
    "GrowthRate": 5.9,
    "ESG_Overall": 58.4,
    "ESG_Environmental": 87.6,
    "ESG_Social": 41.6,
    "ESG_Governance": 46.1,
    "CarbonEmissions": 378090.2,
    "WaterUsage": 378090.2,
    "EnergyConsumption": 756180.5
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2015,
    "Revenue": 7090.7,
    "ProfitMargin": 10.6,
    "MarketCap": 14828.8,
    "GrowthRate": 7,
    "ESG_Overall": 74.4,
    "ESG_Environmental": 69.4,
    "ESG_Social": 87.8,
    "ESG_Governance": 66.1,
    "CarbonEmissions": 506391,
    "WaterUsage": 506391,
    "EnergyConsumption": 1012782
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2016,
    "Revenue": 7395.2,
    "ProfitMargin": 10.4,
    "MarketCap": 17692.4,
    "GrowthRate": 4.3,
    "ESG_Overall": 75.5,
    "ESG_Environmental": 69.3,
    "ESG_Social": 89.8,
    "ESG_Governance": 67.6,
    "CarbonEmissions": 528938.5,
    "WaterUsage": 528938.5,
    "EnergyConsumption": 1057876.9
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2017,
    "Revenue": 7077.8,
    "ProfitMargin": 10.7,
    "MarketCap": 14011.4,
    "GrowthRate": -4.3,
    "ESG_Overall": 76.8,
    "ESG_Environmental": 71.8,
    "ESG_Social": 92.2,
    "ESG_Governance": 66.6,
    "CarbonEmissions": 493832.6,
    "WaterUsage": 493832.6,
    "EnergyConsumption": 987665.3
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2018,
    "Revenue": 6957.5,
    "ProfitMargin": 8.2,
    "MarketCap": 9292.2,
    "GrowthRate": -1.7,
    "ESG_Overall": 76.6,
    "ESG_Environmental": 69.5,
    "ESG_Social": 92.8,
    "ESG_Governance": 67.6,
    "CarbonEmissions": 496422.5,
    "WaterUsage": 496422.5,
    "EnergyConsumption": 992845
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2019,
    "Revenue": 6690.8,
    "ProfitMargin": 9.7,
    "MarketCap": 8033.5,
    "GrowthRate": -3.8,
    "ESG_Overall": 77,
    "ESG_Environmental": 67.2,
    "ESG_Social": 98.8,
    "ESG_Governance": 64.9,
    "CarbonEmissions": 488275.3,
    "WaterUsage": 488275.3,
    "EnergyConsumption": 976550.7
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2020,
    "Revenue": 6751.9,
    "ProfitMargin": 8.7,
    "MarketCap": 7083.4,
    "GrowthRate": 0.9,
    "ESG_Overall": 78.5,
    "ESG_Environmental": 70.2,
    "ESG_Social": 98.2,
    "ESG_Governance": 67,
    "CarbonEmissions": 478492.5,
    "WaterUsage": 478492.5,
    "EnergyConsumption": 956984.9
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2021,
    "Revenue": 6397.5,
    "ProfitMargin": 10.1,
    "MarketCap": 10983.2,
    "GrowthRate": -5.2,
    "ESG_Overall": 78.2,
    "ESG_Environmental": 74.1,
    "ESG_Social": 95.1,
    "ESG_Governance": 65.5,
    "CarbonEmissions": 435991,
    "WaterUsage": 435991,
    "EnergyConsumption": 871982
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2022,
    "Revenue": 6583.8,
    "ProfitMargin": 10.3,
    "MarketCap": 8606.9,
    "GrowthRate": 2.9,
    "ESG_Overall": 79.6,
    "ESG_Environmental": 75.2,
    "ESG_Social": 95.3,
    "ESG_Governance": 68.3,
    "CarbonEmissions": 443275.8,
    "WaterUsage": 443275.8,
    "EnergyConsumption": 886551.6
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2023,
    "Revenue": 6810.4,
    "ProfitMargin": 11.1,
    "MarketCap": 9866,
    "GrowthRate": 3.4,
    "ESG_Overall": 79.6,
    "ESG_Environmental": 75.4,
    "ESG_Social": 95.2,
    "ESG_Governance": 68.2,
    "CarbonEmissions": 457696.4,
    "WaterUsage": 457696.4,
    "EnergyConsumption": 915392.8
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2024,
    "Revenue": 7168.5,
    "ProfitMargin": 13.7,
    "MarketCap": 17539,
    "GrowthRate": 5.3,
    "ESG_Overall": 81.4,
    "ESG_Environmental": 78.2,
    "ESG_Social": 95,
    "ESG_Governance": 71.1,
    "CarbonEmissions": 468000.4,
    "WaterUsage": 468000.4,
    "EnergyConsumption": 936000.8
  },
  {
    "CompanyID": 8,
    "CompanyName": "Nissan Motor Co Ltd",
    "Industry": "Healthcare",
    "Region": "Europe",
    "Year": 2025,
    "Revenue": 7117.1,
    "ProfitMargin": 8.6,
    "MarketCap": 10386.3,
    "GrowthRate": -0.7,
    "ESG_Overall": 81.6,
    "ESG_Environmental": 77.1,
    "ESG_Social": 97.6,
    "ESG_Governance": 69.9,
    "CarbonEmissions": 469707.3,
    "WaterUsage": 469707.3,
    "EnergyConsumption": 939414.6
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2015,
    "Revenue": 1490.2,
    "ProfitMargin": 11.9,
    "MarketCap": 4559,
    "GrowthRate": 9.2,
    "ESG_Overall": 59.8,
    "ESG_Environmental": 37.8,
    "ESG_Social": 77.7,
    "ESG_Governance": 63.7,
    "CarbonEmissions": 69681.3,
    "WaterUsage": 41808.8,
    "EnergyConsumption": 139362.7
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2016,
    "Revenue": 1761.8,
    "ProfitMargin": 9.7,
    "MarketCap": 4234.3,
    "GrowthRate": 18.2,
    "ESG_Overall": 58.8,
    "ESG_Environmental": 38,
    "ESG_Social": 78.7,
    "ESG_Governance": 59.7,
    "CarbonEmissions": 82263.8,
    "WaterUsage": 49358.3,
    "EnergyConsumption": 164527.5
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2017,
    "Revenue": 2085,
    "ProfitMargin": 15.3,
    "MarketCap": 7991.2,
    "GrowthRate": 18.3,
    "ESG_Overall": 60.2,
    "ESG_Environmental": 37.2,
    "ESG_Social": 77.2,
    "ESG_Governance": 66.2,
    "CarbonEmissions": 97986.2,
    "WaterUsage": 58791.7,
    "EnergyConsumption": 195972.4
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2018,
    "Revenue": 2575.4,
    "ProfitMargin": 14.1,
    "MarketCap": 5543,
    "GrowthRate": 23.5,
    "ESG_Overall": 63.5,
    "ESG_Environmental": 40.8,
    "ESG_Social": 81.7,
    "ESG_Governance": 68.1,
    "CarbonEmissions": 117733.8,
    "WaterUsage": 70640.3,
    "EnergyConsumption": 235467.6
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2019,
    "Revenue": 3208.8,
    "ProfitMargin": 11.2,
    "MarketCap": 8416.4,
    "GrowthRate": 24.6,
    "ESG_Overall": 63.3,
    "ESG_Environmental": 40.5,
    "ESG_Social": 83.8,
    "ESG_Governance": 65.6,
    "CarbonEmissions": 147097.1,
    "WaterUsage": 88258.2,
    "EnergyConsumption": 294194.1
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2020,
    "Revenue": 3584.9,
    "ProfitMargin": 10.1,
    "MarketCap": 10662.5,
    "GrowthRate": 11.7,
    "ESG_Overall": 63.1,
    "ESG_Environmental": 39.7,
    "ESG_Social": 84.7,
    "ESG_Governance": 64.9,
    "CarbonEmissions": 165277.3,
    "WaterUsage": 99166.4,
    "EnergyConsumption": 330554.5
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2021,
    "Revenue": 4399.8,
    "ProfitMargin": 8.5,
    "MarketCap": 7008.7,
    "GrowthRate": 22.7,
    "ESG_Overall": 63.8,
    "ESG_Environmental": 39.7,
    "ESG_Social": 84.3,
    "ESG_Governance": 67.3,
    "CarbonEmissions": 202835.4,
    "WaterUsage": 121701.3,
    "EnergyConsumption": 405670.9
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2022,
    "Revenue": 4673,
    "ProfitMargin": 6.7,
    "MarketCap": 8480.9,
    "GrowthRate": 6.2,
    "ESG_Overall": 65.3,
    "ESG_Environmental": 43.5,
    "ESG_Social": 83.4,
    "ESG_Governance": 69,
    "CarbonEmissions": 209222.4,
    "WaterUsage": 125533.4,
    "EnergyConsumption": 418444.8
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2023,
    "Revenue": 5102.1,
    "ProfitMargin": 4.4,
    "MarketCap": 5222,
    "GrowthRate": 9.2,
    "ESG_Overall": 63.3,
    "ESG_Environmental": 45,
    "ESG_Social": 80.8,
    "ESG_Governance": 64,
    "CarbonEmissions": 225770.9,
    "WaterUsage": 135462.6,
    "EnergyConsumption": 451541.9
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2024,
    "Revenue": 5853.9,
    "ProfitMargin": 6.3,
    "MarketCap": 5804.7,
    "GrowthRate": 14.7,
    "ESG_Overall": 63.2,
    "ESG_Environmental": 45.6,
    "ESG_Social": 81.9,
    "ESG_Governance": 62.1,
    "CarbonEmissions": 257772.5,
    "WaterUsage": 154663.5,
    "EnergyConsumption": 515545
  },
  {
    "CompanyID": 9,
    "CompanyName": "Fujitsu Ltd",
    "Industry": "Technology",
    "Region": "North America",
    "Year": 2025,
    "Revenue": 6764,
    "ProfitMargin": 4.5,
    "MarketCap": 5954.9,
    "GrowthRate": 15.5,
    "ESG_Overall": 63.5,
    "ESG_Environmental": 48.4,
    "ESG_Social": 82.6,
    "ESG_Governance": 59.6,
    "CarbonEmissions": 291193.2,
    "WaterUsage": 174715.9,
    "EnergyConsumption": 582386.4
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2015,
    "Revenue": 48720,
    "ProfitMargin": 11.9,
    "MarketCap": 186028.6,
    "GrowthRate": 4.2,
    "ESG_Overall": 62.2,
    "ESG_Environmental": 81.7,
    "ESG_Social": 62.5,
    "ESG_Governance": 42.5,
    "CarbonEmissions": 1530517.6,
    "WaterUsage": 918310.6,
    "EnergyConsumption": 3061035.3
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2016,
    "Revenue": 56121.2,
    "ProfitMargin": 9.4,
    "MarketCap": 134112.7,
    "GrowthRate": 15.2,
    "ESG_Overall": 64.8,
    "ESG_Environmental": 79.6,
    "ESG_Social": 68.6,
    "ESG_Governance": 46.2,
    "CarbonEmissions": 1803672,
    "WaterUsage": 1082203.2,
    "EnergyConsumption": 3607344.1
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2017,
    "Revenue": 60556.9,
    "ProfitMargin": 8.6,
    "MarketCap": 86036,
    "GrowthRate": 7.9,
    "ESG_Overall": 65,
    "ESG_Environmental": 79.2,
    "ESG_Social": 67.5,
    "ESG_Governance": 48.5,
    "CarbonEmissions": 1955375.5,
    "WaterUsage": 1173225.3,
    "EnergyConsumption": 3910751
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2018,
    "Revenue": 65683.3,
    "ProfitMargin": 11,
    "MarketCap": 223764.9,
    "GrowthRate": 8.5,
    "ESG_Overall": 65.1,
    "ESG_Environmental": 79.7,
    "ESG_Social": 70,
    "ESG_Governance": 45.8,
    "CarbonEmissions": 2109725.6,
    "WaterUsage": 1265835.4,
    "EnergyConsumption": 4219451.2
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2019,
    "Revenue": 72498.6,
    "ProfitMargin": 11,
    "MarketCap": 215468.5,
    "GrowthRate": 10.4,
    "ESG_Overall": 64.2,
    "ESG_Environmental": 77.8,
    "ESG_Social": 72.1,
    "ESG_Governance": 42.5,
    "CarbonEmissions": 2374857.6,
    "WaterUsage": 1424914.5,
    "EnergyConsumption": 4749715.1
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2020,
    "Revenue": 79033.4,
    "ProfitMargin": 13.5,
    "MarketCap": 313712.7,
    "GrowthRate": 9,
    "ESG_Overall": 65.8,
    "ESG_Environmental": 81.3,
    "ESG_Social": 73.5,
    "ESG_Governance": 42.4,
    "CarbonEmissions": 2492114.3,
    "WaterUsage": 1495268.6,
    "EnergyConsumption": 4984228.6
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2021,
    "Revenue": 79619.8,
    "ProfitMargin": 12,
    "MarketCap": 263994,
    "GrowthRate": 0.7,
    "ESG_Overall": 67,
    "ESG_Environmental": 81.8,
    "ESG_Social": 75.4,
    "ESG_Governance": 43.9,
    "CarbonEmissions": 2497067.9,
    "WaterUsage": 1498240.8,
    "EnergyConsumption": 4994135.9
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2022,
    "Revenue": 93510.8,
    "ProfitMargin": 14.4,
    "MarketCap": 446629.1,
    "GrowthRate": 17.4,
    "ESG_Overall": 67.1,
    "ESG_Environmental": 79.8,
    "ESG_Social": 78.1,
    "ESG_Governance": 43.5,
    "CarbonEmissions": 2998092.6,
    "WaterUsage": 1798855.6,
    "EnergyConsumption": 5996185.2
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2023,
    "Revenue": 108029.1,
    "ProfitMargin": 17.3,
    "MarketCap": 416982,
    "GrowthRate": 15.5,
    "ESG_Overall": 67.4,
    "ESG_Environmental": 79.5,
    "ESG_Social": 77.9,
    "ESG_Governance": 44.9,
    "CarbonEmissions": 3476430.3,
    "WaterUsage": 2085858.2,
    "EnergyConsumption": 6952860.6
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2024,
    "Revenue": 117939.2,
    "ProfitMargin": 14.9,
    "MarketCap": 610070,
    "GrowthRate": 9.2,
    "ESG_Overall": 68.6,
    "ESG_Environmental": 77.8,
    "ESG_Social": 78.2,
    "ESG_Governance": 50,
    "CarbonEmissions": 3864217,
    "WaterUsage": 2318530.2,
    "EnergyConsumption": 7728434
  },
  {
    "CompanyID": 10,
    "CompanyName": "Yamaha Motor",
    "Industry": "Technology",
    "Region": "Latin America",
    "Year": 2025,
    "Revenue": 104787.3,
    "ProfitMargin": 17.1,
    "MarketCap": 412517.1,
    "GrowthRate": -11.2,
    "ESG_Overall": 69.6,
    "ESG_Environmental": 80.9,
    "ESG_Social": 79.9,
    "ESG_Governance": 48.1,
    "CarbonEmissions": 3319085.3,
    "WaterUsage": 1991451.2,
    "EnergyConsumption": 6638170.6
  }
];